import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { midas } from '@resurs/midas'
import * as smoothScroll from 'smoothscroll-polyfill'
import { Container, Columns, Column } from '../Layout'

function capitalise(string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export class Toast extends PureComponent {
  constructor(props) {
    super(props)

    this.state = { toastActive: true }
    smoothScroll.polyfill()
  }

  componentDidMount() {
    this.scrollToToast()
  }

  scrollToToast() {
    const el = document.querySelector('#toast')
    if (this.state.toastActive) {
      const rect = el.getBoundingClientRect()
      window.scroll({
        top: rect + window.pageYOffset,
        left: 0,
        behavior: 'smooth',
      })
    }
  }

  render() {
    const active = this.state.toastActive

    return (
      active && (
        <div>
          <Container grid960={!this.props.inModal}>
            <Columns>
              {!this.props.inModal && <Column col2 colMd12 />}
              {!this.props.inModal ? (
                <Column col8 colMd12>
                  <div
                    id="toast"
                    className={`${midas.toast} ${
                      midas[`toast${capitalise(this.props.type)}`]
                    }`}
                  >
                    <i className={`${midas[this.props.icon]}`} />
                    <span style={{ paddingTop: '.5rem' }}>
                      {this.props.text}
                    </span>
                    <div className={midas.toastSectionRight}>
                      <button
                        className={`${midas.button} ${midas.buttonClear}`}
                        onClick={() => this.setState({ toastActive: false })}
                      />
                    </div>
                  </div>
                  {this.props.devText && <code>{this.props.devText}</code>}
                </Column>
              ) : (
                <Column col12>
                  <div
                    id="toast"
                    className={`${midas.toast} ${
                      midas[`toast${capitalise(this.props.type)}`]
                    }`}
                  >
                    <i className={`${midas[this.props.icon]}`} />
                    <span style={{ paddingTop: '.5rem' }}>
                      {this.props.text}
                    </span>
                    <div className={midas.toastSectionRight}>
                      <button
                        className={`${midas.button} ${midas.buttonClear}`}
                        onClick={() => this.setState({ toastActive: false })}
                      />
                    </div>
                  </div>
                  {this.props.devText && <code>{this.props.devText}</code>}
                </Column>
              )}

              {!this.props.inModal && <Column col2 colMd12 />}
            </Columns>
          </Container>
        </div>
      )
    )
  }
}

Toast.defaultProps = {
  devText: null,
  inModal: false,
}

Toast.propTypes = {
  type: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  devText: PropTypes.string,
  inModal: PropTypes.bool,
}
